import { useState } from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';
import { SectionHeader } from '../../components/base/SectionHeader';

export default function LandEvaluationPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    city: '',
    district: '',
    block: '',
    parcel: '',
    area: '',
    purpose: '',
    message: '',
    kvkk: false
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d47fin534biqimnfogtg', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.error('Form gönderimi hatası:', error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const processSteps = [
    {
      step: '01',
      title: 'Başvuru',
      description: 'Formu doldurarak başvurunuzu yapın'
    },
    {
      step: '02',
      title: 'İnceleme',
      description: 'Uzman ekibimiz arsansı değerlendirir'
    },
    {
      step: '03',
      title: 'Rapor',
      description: 'Detaylı fizibilite raporu hazırlanır'
    },
    {
      step: '04',
      title: 'Sunum',
      description: 'Size özel proje önerisi sunulur'
    }
  ];

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <section className="pt-24 pb-16 flex items-center justify-center min-h-screen">
          <div className="max-w-2xl mx-auto px-4 text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-6">
              <i className="ri-check-line text-[32px] text-green-600"></i>
            </div>
            <h1 className="text-[24px] font-bold text-[#0e3851] mb-4">
              Başvurunuz Alındı!
            </h1>
            <p className="text-[16px] text-gray-600 mb-6">
              Arsa değerlendirme başvurunuz başarıyla alınmıştır. Uzman ekibimiz en kısa sürede 
              sizinle iletişime geçerek değerlendirme sürecini başlatacaktır.
            </p>
            <div className="bg-gray-50 rounded-2xl p-6 mb-6">
              <h3 className="text-[16px] font-semibold text-[#0e3851] mb-3">Başvuru Özeti:</h3>
              <div className="text-left space-y-2 text-[14px]">
                <div><strong>Ad Soyad:</strong> {formData.fullName}</div>
                <div><strong>Telefon:</strong> {formData.phone}</div>
                <div><strong>Konum:</strong> {formData.city} / {formData.district}</div>
                <div><strong>Arsa Alanı:</strong> {formData.area} m²</div>
              </div>
            </div>
            <p className="text-[14px] text-gray-500 mb-8">
              Değerlendirme süreci genellikle 3-5 iş günü sürmektedir.
            </p>
            <Button onClick={() => window.location.href = '/'}>
              <i className="ri-home-line mr-2"></i>
              Anasayfaya Dön
            </Button>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Arsansı Değerlendirelim
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Arsansı potansiyelini keşfedin. Uzman ekibimiz arsansı ücretsiz değerlendirerek 
              size en uygun proje önerisini sunar.
            </p>
          </div>
        </div>
      </section>

      {/* Süreç */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Değerlendirme Süreci"
            subtitle="Arsanızın değerlendirilmesi 4 aşamalı süreçle gerçekleşir"
            centered
            className="mb-12"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#0e3851] text-white rounded-full mx-auto mb-4 text-[20px] font-bold">
                  {step.step}
                </div>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">{step.title}</h3>
                <p className="text-[15px] text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Arsa Değerlendirme Formu"
            subtitle="Arsanız hakkında detaylı bilgileri paylaşın"
            centered
            className="mb-8"
          />
          
          <Card>
            <form id="arsa-degerlendirme-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input 
                    type="text" 
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="Adınızı ve soyadınızı girin"
                  />
                </div>
                
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Telefon *
                  </label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="Telefon numaranızı girin"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[14px] font-medium text-gray-700 mb-2">
                  E-posta *
                </label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                  placeholder="E-posta adresinizi girin"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    İl *
                  </label>
                  <select 
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px] pr-8"
                  >
                    <option value="">İl seçin</option>
                    <option value="İstanbul">İstanbul</option>
                    <option value="Ankara">Ankara</option>
                    <option value="İzmir">İzmir</option>
                    <option value="Bursa">Bursa</option>
                    <option value="Antalya">Antalya</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    İlçe *
                  </label>
                  <input 
                    type="text" 
                    name="district"
                    value={formData.district}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="İlçe adını girin"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Ada *
                  </label>
                  <input 
                    type="text" 
                    name="block"
                    value={formData.block}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="Ada numarasını girin"
                  />
                </div>
                
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Parsel *
                  </label>
                  <input 
                    type="text" 
                    name="parcel"
                    value={formData.parcel}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="Parsel numarasını girin"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Arsa Alanı (m²) *
                  </label>
                  <input 
                    type="number" 
                    name="area"
                    value={formData.area}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                    placeholder="Arsa alanını girin"
                  />
                </div>
                
                <div>
                  <label className="block text-[14px] font-medium text-gray-700 mb-2">
                    Kullanım Amacı *
                  </label>
                  <select 
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px] pr-8"
                  >
                    <option value="">Kullanım amacını seçin</option>
                    <option value="Konut">Konut</option>
                    <option value="Ticari">Ticari</option>
                    <option value="Karma">Karma (Konut + Ticari)</option>
                    <option value="Sanayi">Sanayi</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-[14px] font-medium text-gray-700 mb-2">
                  Ek Bilgiler
                </label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[15px]"
                  placeholder="Arsanız hakkında ek bilgiler paylaşın (maksimum 500 karakter)"
                ></textarea>
                <div className="text-right text-[12px] text-gray-500 mt-1">
                  {formData.message.length}/500
                </div>
              </div>

              <div>
                <label className="block text-[14px] font-medium text-gray-700 mb-2">
                  Dosya Yükleme
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center">
                  <i className="ri-upload-cloud-line text-[32px] text-gray-400 mb-2"></i>
                  <p className="text-[14px] text-gray-600 mb-2">
                    Arsa belgelerini yükleyin (PDF, JPG)
                  </p>
                  <input 
                    type="file" 
                    accept=".pdf,.jpg,.jpeg,.png"
                    className="hidden"
                    id="file-upload"
                  />
                  <label 
                    htmlFor="file-upload"
                    className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors text-[14px]"
                  >
                    <i className="ri-attachment-line mr-2"></i>
                    Dosya Seç
                  </label>
                  <p className="text-[12px] text-gray-500 mt-2">
                    Maksimum dosya boyutu: 10MB
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <input 
                  type="checkbox" 
                  name="kvkk"
                  checked={formData.kvkk}
                  onChange={handleInputChange}
                  required
                  className="mt-1 mr-3"
                />
                <label className="text-[14px] text-gray-600">
                  <span className="text-red-500">*</span> Kişisel verilerimin işlenmesine ilişkin 
                  <a href="/kvkk" className="text-[#0e3851] hover:underline ml-1">KVKK Aydınlatma Metni</a>'ni 
                  okudum ve kabul ediyorum.
                </label>
              </div>

              <Button type="submit" size="lg" className="w-full">
                <i className="ri-send-plane-line mr-2"></i>
                Değerlendirme Talebini Gönder
              </Button>
            </form>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
}
